import React, {createRef} from "react";
import PropTypes from "prop-types";
import BaseComponent from "../../../../../lib/components/BaseComponent";
import SystemService from "../../../../../lib/model/service/system/SystemService";
import CM from "../../../../model/system/CM";
import Window from "../../../../../lib/components/window/Window";
import SelectableItem from "../../../../../lib/components/selectableDragList/SelectableItem";
import WriteAuthorization from "../../../../../lib/model/service/system/dto/WriteAuthorization";
import {toast} from "react-toastify";
import shortid from "shortid";
import SelectableDragList from "../../../../../lib/components/selectableDragList/SelectableDragList";
import HorizontalLayout from "../../../../../lib/components/layouts/HorizontalLayout";
import Button from "../../buttons/Button";
import VerticalLayout from "../../../../../lib/components/layouts/VerticalLayout";

class Authorization extends BaseComponent {

  constructor(props) {
    super(props);
    this.state = {
      selectedPermissionsList: null,
    };
    this.selectableDragListRef = createRef();
    this.userContext = CM.get().getUserContext();
  }

  componentDidMount() {
    super.componentDidMount();
    this.selectableDragListRef.current.setDefaultSelectedTargets();
  }

  buildWriteDto() {
    let dto;
    switch (this.props.mode) {
      case 'user':
        dto = new WriteAuthorization(parseInt(this.userContext.accounts[0]), null, this.props.recId);
        break;
      case 'userGroup':
        dto = new WriteAuthorization(parseInt(this.userContext.accounts[0]), this.props.recId, null);
        break;
      default:
        throw new DOMException('mode ist nicht angegeben!');
    }
    return dto;
  }

  initSelectoItems() {
    let items = [];
    for (let index in this.props.privileges) {
      let privilege = this.props.privileges[index];

      // filtere entsprechende Einträge gemäss dem mode.
      switch (this.props.mode) {
        case 'user':
          if (!privilege.name.startsWith('User\\')) {
            privilege = null;
          }
          break;
        case 'userGroup':
          if (privilege.name.startsWith('User\\')) {
            privilege = null;
          }
          break;
        default:
          throw new DOMException('mode ist nicht angegeben!');
      }
      if (privilege !== null) {
        items.push(<SelectableItem
          key={shortid()}
          elementId={privilege.name}
          active={privilege.connected}>
          {privilege.description}
        </SelectableItem>);
      }
    }
    return items;
  }

  onSaveButtonClick(e) {
    let privilegesToSave = {};
    for (let index in this.props.privileges) {
      let privilege = this.props.privileges[index];

      let found = this.state.selectedPermissionsList.includes(privilege.name);
      privilegesToSave[privilege.name] = {connected: found};
    }

    let dtoWriteAuthorization = this.buildWriteDto();
    dtoWriteAuthorization.setPrivileges(privilegesToSave);

    CM.get().doJsonAjax(CM.get().getServiceUrl(SystemService.NAME), dtoWriteAuthorization, (response) => {
      if (response.success) {
        toast.success('Berechtigungen wurden erfolgreich gespeichert.');
      } else {
        toast.error(response.message);
      }
    });
  }

  render() {
    let permissionSelectoItems = this.initSelectoItems();
    let title = this.props.mode === 'user' ? 'Berechtigungen (Benutzer)' : 'Berechtigungen (Benutzergruppe)';

    return <Window title={title}>
      <VerticalLayout className='gap-3'>
        <SelectableDragList ref={this.selectableDragListRef} onChange={(list) => this.state.selectedPermissionsList = list}>
          {permissionSelectoItems}
        </SelectableDragList>
        <HorizontalLayout className='justify-end gap-x-5 mt-5'>
          <Button size='small' onClick={(e) => this.onSaveButtonClick(e)}>Berechtigungen speichern</Button>
        </HorizontalLayout>
      </VerticalLayout>
    </Window>;
  }
}

Authorization.propTypes = {
  recId: PropTypes.number, mode: PropTypes.oneOf(['user', 'userGroup']), privileges: PropTypes.object,
}
export default Authorization;
